module.exports = __webpack_public_path__ + "static/media/optioned-building.b2343642.svg";